import styled from "styled-components";

export const ResetPasswordStyled = styled.section`
  .login__submit {
    margin-top: 10px;
  }

  p.error {
    color: red;
    font-size: 17px;

    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
  
  .login__subtitle {
    // The heading only carries a bottom margin from 992px up, so on a phone
    // the two lines ran into each other.
    margin: 14px 0 24px;
    @media (min-width: 992px) {
      margin-top: 4px;
    }
    color: var(--5-f-6472, #5F6472);
    font-size: 14px;
    line-height: 140%;
  }

  .login__password-rules {
    margin-top: 16px;
    color: #97A0BB;
    font-size: 13px;
    line-height: 150%;

    span {
      font-weight: 500;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      // The row gap separates one rule from the NEXT rule's bullet, so it has
      // to be the wider of the two; the bullet sits close to its own text.
      gap: 2px 14px;
      margin: 6px 0 0;
      padding-left: 2px;
      list-style: none;
    }

    li {
      display: flex;
      align-items: baseline;
      gap: 5px;

      // Drawn here rather than with list-style: an outside marker is painted
      // beyond the item's own box, so it landed inside the row gap and read
      // as if it belonged to the end of the previous rule.
      &::before {
        content: "•";
      }
    }
  }

  .reset-password__thanks {
    text-align: center;
    h1 {
      margin-bottom: 0;
    }
    p {
      margin-top: 20px;
      margin-bottom: 30px;
      color: var(--5-f-6472, #5F6472);
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
    }
    .login__submit {
      width: 100%;
      max-width: 300px;
      margin: 0;
    }
  }
`
